import {Component} from "preact";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import BackdropCover from "../../../../../common/backdrop-cover";
import Spinner from "../../../../../common/spinner";
import {translate} from "../../../../../../services/TranslateService";
import Toolbar from "../../../../../layout/toolbar";
import SectionComponent from "../../../../../layout/section-component";
import ToolbarButton from "../../../../../common/toolbar-button";
import ArrowLeftIcon from "mdi-preact/ArrowLeftIcon";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import SendIcon from "mdi-preact/SendIcon";
import ScrollableSection from "../../../../../layout/scrollable-section";
import CustomInput from "../../../../../common/custom-input";
import FormRow from "../../../../../common/form-row";
import JWTClient from "../../../../../../services/JWTClient";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import ConfigService from "../../../../../../services/ConfigService";
import JsonApiDeserializer from "../../../../../../services/JsonApiDeserializer";
import Text from "../../../../../common/text";
import styles from "./styles.scss";

export default class CreateGroupChat extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false,
            title: '',
            description: '',
            profile: ConfigService.userProfile()
        };
    }

    static defaultProps = {
        onNavigate: () => {},
        selectedContacts: {}
    };

    render(props, state, context) {
        const spinner = <BackdropCover><Spinner/></BackdropCover>;


        return (
            <VerticalUiContainer>
                {this.state.loading ? spinner : null}
                <Toolbar style={{borderBottom: '1px solid #eee', height: '4em'}}>
                    <SectionComponent style={{flexGrow: 0}}>
                        <ToolbarButton onClick={this.backToContacts} title={translate('action.back')}><ArrowLeftIcon/></ToolbarButton>
                    </SectionComponent>

                    <div style={{flexGrow: 2}}>
                        <ToolbarTitle><Text text={'chat.group.new.title'}/></ToolbarTitle>
                    </div>

                    <SectionComponent style={{flexShrink: 0}}>
                        <ToolbarButton onClick={this.submit} title={translate('action.send')}><SendIcon/></ToolbarButton>
                    </SectionComponent>
                </Toolbar>

                <ScrollableSection>
                    <form onSubmit={this.submit} class={styles.form}>
                        <FormRow>
                            <label className={styles.label} for='global-top-bar-group-chat-title'><Text text={'chat.group.form.title-label'}/></label>
                            <CustomInput id={'global-top-bar-group-chat-title'} value={this.state.title} onChange={this.setTitle} />
                        </FormRow>
                        <FormRow>
                            <label className={styles.label} for='global-top-bar-group-chat-description'><Text text={'chat.group.form.title-description'}/></label>
                            <CustomInput id={'global-top-bar-group-chat-description'} value={this.state.description} onChange={this.setDescription} />
                        </FormRow>
                    </form>
                </ScrollableSection>

            </VerticalUiContainer>
        );
    }

    submit = () => {
        this.setState({loading: true, error: false});
        if (!this.state.title.length) {
            this.setState({errors: ['title.required']});
            return;
        }

        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat') + '/chats';


        JWTClient.fetch(url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                type: 'groupChat',
                title: this.state.title,
                description: this.state.description,
                subjects: Object.keys(this.props.selectedContacts).map(c => {
                    return {
                        name: this.props.selectedContacts[c].username,
                        email: this.props.selectedContacts[c].email,
                        reference: this.props.selectedContacts[c].reference
                    };
                }).concat([{
                    name: this.state.profile.username,
                    email: this.state.profile.email,
                    reference: this.state.profile.reference
                }])
            })
        })
            .then(res => {
                const chat = JsonApiDeserializer.deserializeItem(res.data, res.included);
                this.props.onNavigate('read', {chat: chat});
            })
            .finally(() => {
                this.setState({loading: false})
            })
        ;
    };
    
    backToContacts = () => {
        this.props.onNavigate('create', {selectedContacts: this.props.selectedContacts})
    };

    setTitle = (inputEvent) => {
        this.setState({title: inputEvent.target.value});
    };

    setDescription = (inputEvent) => {
        this.setState({description: inputEvent.target.value});
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/create-group-chat/index.js